export function Loading() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-[200px] items-center justify-center text-sm text-text-muted"
    >
      Loading…
    </div>
  );
}
